import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin, BlockAM } from "../../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../../config/config.json";
import { Table, Tooltip, Select, Col, Row, Pagination, Input, Modal, Checkbox } from 'antd';
import { Link } from 'react-router-dom'
import FullLoader from "../../../assets/images/full-page-loader.gif"
import prevIcon from '../../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../../assets/images/icons/chevron-right.svg';
import addIcon from '../../../assets/images/icons/add.svg';
import noData from '../../../assets/images/data-graph/no-data.svg';
import TableLoader from "../../TableLoader";
import errorData from '../../../assets/images/data-graph/error-data.svg';
import mediaKitIcon from '../../../assets/images/icons/download_gray_icon.svg';
import CategoryCreate from "./CategoryCreate";
import { saveAs } from "file-saver";
import { notifyfailure, notifysuccess } from "../../../utils/toast";
const { Option } = Select;

const CategoryListing = () => {

    const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)
    const [pageView, setPageView] = useState("table")

    // const [checkRole, setCheckRole] = useState("admin")
    const [fileViewId, setFileViewId] = useState("")
    const [fileViewName, setFileViewName] = useState("")
    const [fileViewExt, setFileViewExt] = useState("")
    const [matchTypeValue, setMatchTypeValue] = useState("")


    const columnsAll = [
        {
            title: 'Action',
            dataIndex: 'action',
            width: 70,
            render: (text, record) => {
                return (

                    <div className='btn_group'

                    >
                        {record?.downloadLoading ?

                            <button className="new_integrate_btn_d2 btn btn_primary loader loader_btn_with_icon">
                                <span> Download</span>
                                <img src={FullLoader} alt="USP" className="" />
                            </button>
                            :
                            <Tooltip title="Download">
                                <button className='download_icon download_icon_d2'
                                    onClick={() => {
                                        handleDownload(record.id, record.listName, record.mimetype)
                                    }}
                                >
                                    <img src={mediaKitIcon} alt='USP' /></button>
                            </Tooltip>
                        }
                    </div>
                )
            },
        },

        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            fixed: 'left',
            width: 150,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => <div className='text_dark'>{text}</div>,
        },
        {
            title: 'Name',
            dataIndex: 'listName',
            fixed: 'left',
            key: "listName",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text, record) => <div className='anchor_text_link_d2'
                onClick={() => {
                    setPageView("edit");
                    setFileViewId(record.id)
                    setFileViewName(record.listName)
                    setMatchTypeValue(record.matchTypeValue)
                    setFileViewExt(record.mimetype)
                }}

            >{text}</div>,
        },
        {
            title: 'Match Type',
            dataIndex: 'matchTypeLabel',
            key: 'matchTypeLabel',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: false,
            render: (text) => <div className="text_dark">{text}</div>,
        },
        {
            title: 'Uploaded',
            dataIndex: 'createdAt',
            key: 'createdAt',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: false,
            render: (text) => <div className='text_dark'>{text}</div>,
        },
        {
            title: 'Campaigns',
            dataIndex: 'campaigns',
            key: 'campaigns',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: false,
            render: (text, record) =>
                <>
                    {text === 0 ?
                        <Link className="zero_value_design2" style={{ textDecoration: "none", cursor: "default" }} >{text}</Link> :
                        <Link to={`/campaignGam?listType=excludedCategory&listId=${record.id}`} target="_blank" className='text_primary back_area_increase_d2' >{text}</Link>
                    }
                </>
        },
    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });

    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")

    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + `ops/gam/excludedCategory?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`,
                    // {
                    // filter: filterApplyApiCall
                    // }, 
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    })
                .then((response) => {
                    setData(response.data.data.data)
                    if (response.data.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.metaData?.totalRecords

                        setPage(tempPage)
                    }


                    // setTimeout(() => {
                    setLoading(false)
                    // }, 300)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                });
        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        BlockAM()
        // let status = Cookies.get("token_xapads_ssp") ? true : false;
        // if (status) {
        //     let token = Cookies.get("token_xapads_ssp");
        //     let checkRole = jwtDecode(token).role;
        //     setCheckRole(checkRole)
        // }
        getData()
        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);



    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };


    const handlePageViewEdit = (data, reload) => {
        if (reload === "yes") {
            setApicall(!apiCall)
        }
        setFileViewId("")
        setFileViewName("")
        setFileViewExt("")
        setMatchTypeValue("")
        setPageView(data)

    }

    const handleDownload = async (id, name, ext) => {

        setData(prevData =>
            prevData.map(obj => {
                if (obj["id"] === id) {
                    return { ...obj, downloadLoading: true };
                }
                return obj;
            })
        );

        axios
            .get(
                configData.SERVER_URL +
                `ops/gam/downloadFile?list=excludedCatList&fileId=` +
                id,
                {
                    headers: {
                        "Content-Type": "application/json",
                        // "x-access-token": token,
                    },
                }
            )
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: "text/plain;charset=utf-8",
                });
                saveAs(blob, name + "." + ext);
                notifysuccess("File downloaded successfully")
                setData(prevData =>
                    prevData.map(obj => {
                        if (obj["id"] === id) {
                            return { ...obj, downloadLoading: false };
                        }
                        return obj;
                    })
                );
            })
            .catch((error) => {

                notifyfailure("Error while downloading the file")
                setData(prevData =>
                    prevData.map(obj => {
                        if (obj["id"] === id) {
                            return { ...obj, downloadLoading: false };
                        }
                        return obj;
                    })
                );
            });
    };

    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>
                        <div className='float_text_div'>
                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :
                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>
                                <div className='float_text_div'>
                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
            }
            </>

    };



    return (
        <>


            <div className="container_box--wrapper pt_header"
                style={{ opacity: pageView === "table" ? 1 : 0, display: pageView === "table" ? "block" : "none" }}
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        Excluded Category List
                    </h1>


                </div>
                <div className={data.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height"}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="d_flex justify_content_between">
                                <div className="form_content_block--group">
                                    {!initialLoad &&
                                        <Input
                                            type='text'
                                            className='form_control basic md search_input w_table_search'
                                            placeholder="Search"
                                            value={search}
                                            onChange={(e) => {

                                                if (e.target.value.trim().length === 0) {
                                                    setLoading(true)
                                                }

                                                setSearch(e.target.value)
                                            }}
                                        />
                                    }
                                </div>
                                <div className="btn_group">
                                    {!initialLoad &&
                                        <>

                                            <button className='btn btn_primary w_fit_content md'
                                                onClick={() => { setPageView("create") }}
                                            ><span><img src={addIcon} alt='USP' /> New List</span></button>
                                        </>}
                                </div>
                            </div>
                        </div>
                        <div className="table_content--box --new_layout_table_design table_empty_screen_d2">
                            {loading && !initialLoad &&
                                <div className="table_new_loader_d2">
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>
                            }

                            {initialLoad ?
                                <TableLoader />

                                :
                                <Table
                                    columns={columnsAll}
                                    pageSize={100}
                                    dataSource={data}
                                    onChange={handleTableChange}
                                    pagination={false}
                                    rowKey={(record) => record.id}
                                    locale={locale}
                                    scroll={{ x: 1500, y: 'calc(100vh - 30.9rem' }} />


                            }

                            {data.length > 0 &&
                                <Row className="custom_pagination--container">
                                    <Col span={6}>
                                        <div className="form_content_block--group mb_0">
                                            <Select
                                                className='form_select basic sm no_search'
                                                value={page.pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{ width: 80 }}
                                                showSearch={false}
                                                options={[
                                                    { value: 10, label: 10 },
                                                    { value: 20, label: 20 },
                                                    { value: 50, label: 50 },
                                                    { value: 100, label: 100 },
                                                ]} />
                                            <label className='custom_pagination--label'>
                                                items per page
                                            </label>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <span className="custom_pagination--total-text">
                                            {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                        </span>
                                    </Col>
                                    <Col span={6}>
                                        <Pagination
                                            current={page.current}  // Pass individual props instead of spreading them
                                            pageSize={page.pageSize}
                                            total={page.total}
                                            onChange={handlePageChange}
                                            showSizeChanger={false}
                                            itemRender={itemRender}
                                            className="custom_pagination" />
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
                </div>
            </div>



            {pageView === "create" &&
                <CategoryCreate
                    mode="create"
                    handlePageViewChange={handlePageViewEdit}
                />
            }


            {pageView === "edit" &&
                <CategoryCreate
                    mode="edit"
                    handlePageViewChange={handlePageViewEdit}
                    fileViewId={fileViewId}
                    fileViewName={fileViewName}
                    fileViewExt={fileViewExt}
                    matchTypeValue={matchTypeValue}
                />
            }



        </>
    );
};

export default CategoryListing;
